export interface CataleanWishlist {
  uuid: string;
  name: string;
  structureUUID: string;
  recipientsNames: string[];
  recipientsCount: number;
  productsRef: { [key: string]: any }[]
}
